/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions */
import { ArrowRight, Check, FileText, MessageSquareText, Mic2, Video } from "lucide-react";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

import { StoryIdentity } from "./career-story";

const moments = [
  { title: "Experience recorded", detail: "The onboarding project", Icon: FileText },
  { title: "Story explained", detail: "The insight behind the decision", Icon: Video },
  { title: "Answer practiced", detail: "A clearer contribution", Icon: Mic2 },
  {
    title: "Learning carried forward",
    detail: "Ready for the next conversation",
    Icon: MessageSquareText,
  },
];

export const HowToStartSection = () => {
  const { user } = useAuthStore();
  return (
    <>
      <section id="application-tracker" className="folio-section">
        <div className="folio-shell">
          <div className="folio-section-heading">
            <div>
              <p className="folio-eyebrow">Keep what you learn</p>
              <h2>The next chapter starts with more.</h2>
            </div>
            <p>
              Your resume, Spotlight Intro, practice sessions, and applications belong to the same
              career. Keep building on the work you have already put in.
            </p>
          </div>
          <div className="continuity-record">
            <div className="continuity-record-head">
              <StoryIdentity detail="The same person. More to draw on." />
              <span className="folio-label">Avery’s illustrative journey</span>
            </div>
            <ol className="continuity-timeline">
              {moments.map(({ title, detail, Icon }, index) => (
                <li key={title}>
                  <span className="continuity-node">
                    <Icon size={18} />
                  </span>
                  <small>0{index + 1}</small>
                  <h3>{title}</h3>
                  <p>{detail}</p>
                </li>
              ))}
            </ol>
            <div className="continuity-note">
              <Check size={17} />
              <span>
                Takeaway for the next application:{" "}
                <strong>lead with the insight, then explain the decision.</strong>
              </span>
            </div>
          </div>
          <div className="folio-section-bottom">
            <span className="folio-example-note">
              A career keeps moving. Your preparation can move with it.
            </span>
            <Link
              className="folio-text-link"
              to={user ? "/dashboard/application-status" : "/auth/register"}
            >
              Keep track of your applications <ArrowRight size={17} />
            </Link>
          </div>
        </div>
      </section>
      <section className="folio-closing">
        <div className="folio-shell">
          <p className="folio-eyebrow">Now, your story</p>
          <h2>
            There’s more to you
            <br />
            than a resume.
          </h2>
          <p>
            Let recruiters hear your story.
            <br />
            Practice for the conversation ahead.
          </p>
          <Link
            className="folio-button folio-button-light"
            to={user ? "/dashboard/spotlight-intro" : "/auth/register"}
          >
            Create your Spotlight Intro
            <ArrowRight size={18} />
          </Link>
          <Link
            className="folio-text-link closing-practice-link"
            to={user ? "/dashboard/practice-interview" : "/practice-interview"}
          >
            Practice Interview <ArrowRight size={18} />
          </Link>
          <span className="closing-fold" aria-hidden="true" />
        </div>
      </section>
    </>
  );
};
